import PropTypes from "prop-types";

/**
 * Componente legado de migas de pan.
 * Desactivado de raíz a nivel global para que no genere ningún elemento HTML
 * ni ocupe espacio en el DOM, garantizando que NUNCA aparezcan dos barras
 * de migas de pan. Las migas de pan se generan automáticamente de forma
 * exclusiva dentro del componente de encabezado minimalista .page-hero (TitlePages).
 */
const Breadcrumbs = () => null;

Breadcrumbs.propTypes = {
  path: PropTypes.array,
};

export default Breadcrumbs;
